import { globalState } from './state';
import { modalController } from '@ionic/core';

export class ViewManager {
  private static lockCnt: number;

  static lock(graceTime?: number) {
    this.lockCnt++;
    if (this.lockCnt > 1) {
      return;
    }
    if (graceTime !== undefined && graceTime !== 0) {
      setTimeout(async () => {
        if (this.lockCnt) {
          globalState.showBackdrop = true;
        }
      }, graceTime);
    } else {
      globalState.showBackdrop = true;
    }
  }

  static unlock() {
    this.lockCnt = this.lockCnt > 0 ? this.lockCnt - 1 : 0;
    if (this.lockCnt === 0) {
      globalState.showBackdrop = false;
    }
  }

  static async lockWhile<T>(promise: Promise<T> | (() => Promise<T>), graceTime?: number): Promise<T> {
    this.lock(graceTime);
    try {
      if (promise instanceof Function) {
        return await promise();
      } else {
        return await promise;
      }
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      this.unlock();
    }
  }

  static async alert(message: string, title?: string) {
    const content = document.createElement('div');
    content.innerHTML = `<div style="padding: 2rem">
      ${title ? `<div style="font-weight: bold; margin-bottom: 0.5rem; text-align: center">${title}</div>` : ''}
      <div style="text-align: center">${message}</div>
    </div>`;
    const modal = await modalController.create({component: content});
    modal.id = 'alert-modal';
    await modal.present();
    await modal.onWillDismiss();
  }

  static async confirm(message: string): Promise<boolean> {
    return new Promise<boolean>((resolve: Function) => {
      const result = confirm(message);
      resolve(result);
    });

  }

  static async choose(title: string, options: { id: string, name: string }[], currentValue?: string): Promise<{
    id: string,
    name: string
  } | undefined> {
    return new Promise(async (resolve) => {

      const content = document.createElement('div');
      content.style.padding = "2rem";
      content.style.maxWidth = "300px";
      content.style.margin = "auto";

      if (title) {
        const header = document.createElement('div');
        header.style.fontWeight = "bold";
        header.style.marginBottom = "1rem";
        header.style.textAlign = "center";
        header.textContent = title;
        content.appendChild(header);
      }

      const optionContainer = document.createElement('div');
      optionContainer.style.display = "flex";
      optionContainer.style.flexWrap = "wrap";
      optionContainer.style.justifyContent = "center";
      optionContainer.style.gap = "0.5rem";

      options.forEach(option => {
        const button = document.createElement('button');
        button.textContent = option.name;
        button.style.padding = "0.4rem 1rem";
        button.style.cursor = "pointer";
        button.style.borderRadius = "6px";
        button.style.border = option.id === currentValue ? "2px solid var(--color-primary)" : "1px solid #ccc";
        button.style.backgroundColor = option.id === currentValue ? "var(--contrast-10)" : "#fff";

        button.onclick = () => {
          modal.dismiss();
          resolve(option);
        };

        optionContainer.appendChild(button);
      });

      content.appendChild(optionContainer);

      const cancelButton = document.createElement('button');
      cancelButton.textContent = "Abbrechen";
      cancelButton.style.display = "block";
      cancelButton.style.width = "100%";
      cancelButton.style.padding = "0.5rem";
      cancelButton.style.cursor = "pointer";
      cancelButton.style.backgroundColor = "#ddd";
      cancelButton.style.borderRadius = "6px";
      cancelButton.onclick = () => {
        modal.dismiss();
        resolve(undefined);
      };

      content.appendChild(cancelButton);

      const modal = await modalController.create({
        component: content
      });

      await modal.present();
    });
  }
}
